module.exports = __webpack_public_path__ + "static/media/sql.78d85723.png";


//////////////////
// WEBPACK FOOTER
// ./src/project_pictures/sql.png
// module id = 34
// module chunks = 0